import { getCheckboxSheetValue, zeroUnit } from '../../utils'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	const conciliation = injured.conciliation || ''

	let arr = [
		{
			label: '事故责任认定书判断伤者',
			value: setting.blameTypeMap[conciliation.blame],
			key: 'blame',
		},
		{
			label: '医药费发票金额(元)',
			value: zeroUnit(conciliation.medicalAmount, '元'),
			key: 'medicalAmount',
		},
		{
			label: '伤者已自付医药费',
			value: zeroUnit(conciliation.selfPayAmount, '元'),
			key: 'selfPayAmount',
		},
	]

	const otherFee = conciliation.otherFee || [{}]
	for (const [index, item] of otherFee.entries()) {
		arr = arr.concat([
			{
				label: `其他费用名称${index + 1}(可选)`,
				value: item.otherFeeName,
				key: `otherFeeName${index + 1}`,
			},
			{
				label: `其他费用金额${index + 1}(可选)`,
				value: zeroUnit(item.otherAmount, '元'),
				key: `otherAmount${index + 1}`,
			},
		])
	}
	arr.push({
		label: '愿意接受调解协商',
		value: setting.yesNoMap[conciliation.accept],
		key: 'accept',
	})
	if (conciliation.accept === '1') {
		arr = arr.concat([
			{
				label: '诉求金额(除医药费)(元)',
				value: zeroUnit(conciliation.requireAmount, '元'),
				key: 'requireAmount',
			},
			{
				label: '其他需求(可选)',
				value: getCheckboxSheetValue(
					setting.otherRequireMap,
					conciliation.otherRequire
				),
				key: 'otherRequire',
			},
		])
		if (
			Array.isArray(conciliation.otherRequire) &&
			conciliation.otherRequire.includes('03')
		) {
			arr.push({ label: '其他', value: conciliation.remark, key: 'remark' })
		}
	}

	return {
		title: '协商调解意向',
		children: arr,
	}
}
